import $http from './http';

// 获取无需权限采集点
export const getPointList = data => {
    return $http.post('/collect/common/getPointList', data);
};
//获取采集点列表
export const getUnitPointList = data => {
    return $http.post('/collect/common/getUnitPointList', data);
};
//按日
export const getDayData = data => {
    return $http.post('/collect/analysis_mom/getDayData', data);
};
//按周
export const getWeekData = data => {
    return $http.post('/collect/analysis_mom/getWeekData ', data);
};
//按月
export const getMonthData = data => {
    return $http.post('/collect/analysis_mom/getMonthData', data);
};
//按年
export const getYearData = data => {
    return $http.post('/collect/analysis_mom/getYearData', data);
};
//获取系统时间
export const getSysDate = data => {
    return $http.post('/collect/common/getSysDate', data);
};
//导出
export const getExcel = data => {
    return $http.post('/collect/analysis_mom/getExcel', data, {
        responseType: 'blob'
    });

}